import { defineComponent } from "vue";
export default defineComponent({
    name: 'g-cookie-consent',
    data: () => ({
        showBanner: true,
        enableDefault: true,
        enableStatistik: false
    }),
    created() {
        this.showBanner = appHost.config.consentShowBanner || utils.isNullOrEmpty(utils.getCookieValue("288a.CookieStatistik"));
        this.enableStatistik = utils.getCookieValue("288a.CookieStatistik") == "yes";
    },
    methods: {
        setCookieAll() {
            this.enableStatistik = true;
            this.setCoockieCustom();
        },
        setCoockieCustom() {
            //Set
            document.cookie = appHost.config.consentCookie;
            //Custom
            if (this.enableStatistik) {
                document.cookie = appHost.config.statistikCookie;
            }
            else {
                document.cookie = utils.replace(appHost.config.statistikCookie, "=yes", "=no");
            }
            //Cookie
            appHost.config.consentShowBanner = false;
            this.showBanner = false;
            //Events
            this.$appHost.eventBus.emit("cookie_consent_changed");
        },
        setBannerVisible() {
            this.showBanner = true;
        }
    }
});
